module.exports = __webpack_public_path__ + "img/m2-icon.640c8ad.jpg";